import React from "react";
import Logout from "../components/Logout";
import PageHeader from "../components/PageHeader";
import HomeWidgetSettings from "../components/HomeWidgetSettings";

import { faGear } from "@fortawesome/free-solid-svg-icons";

function Settings() {
  return (
    <div>
      <PageHeader pageTitle="Settings" icon={faGear} />

      <h3>Home page widgets</h3>
      <HomeWidgetSettings />

      <Logout />
    </div>
  );
}

export default Settings;
